import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=9932e34a&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=9932e34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9932e34a",
  null
  
)

export default component.exports